import { AnyAction } from 'redux';
import { ApiStatuses } from '../../../../global/models/api-model';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';
import { DocumentUploadActionTypes, DocumentUploadAppState, DocumentUploadState, GenericDocumentUpload } from './document-upload-models';


export const InitialState: DocumentUploadState = {
	showDocumentUpload: false,
	documentUploaded: false,
	documentsUploadedCount: 0,
	stagedDocuments: null,
	showInternationalWarning: false,
	showDemographicWarning: false,
	isReceivingPensionOrPayout: null,
};

export const InitialAppState: DocumentUploadAppState = {
	[DemographicAppKeys.myCPG]: InitialState,
	[DemographicAppKeys.arc]: InitialState,
	[GenericDocumentUpload.MemberDocUpload]: InitialState,
	[GenericDocumentUpload.AdminDocUpload]: InitialState,
};

export const documentUploadReducerByApp = (state = InitialAppState, action: AnyAction): DocumentUploadAppState => {
	const { app } = action;

	switch (action.type) {

		case DocumentUploadActionTypes.UPDATE_DOCUMENT_UPLOAD_STATUS:
			return {
				...state,
				[app]: {
					...state[app],
					documentUploaded: action.payload?.status,
					documentsUploadedCount: action.payload?.documentCount,
				},
			};
		case DocumentUploadActionTypes.TOGGLE_DOCUMENT_UPLOAD:
			return {
				...state,
				[app]: {
					...state[app],
					showDocumentUpload: action.payload?.show,
					showInternationalWarning: action.payload?.showInternationalWarning,
					showDemographicWarning: action.payload?.showDemographicWarning,
				},
			};

		case DocumentUploadActionTypes.STAGE_DOCUMENTS:
			return {
				...state,
				[app]: {
					...state[app],
					stagedDocuments: action.payload,
				},
			};

		case DocumentUploadActionTypes.RESET_DOC_STATE:
			return {
				...state,
				[app]: {
					...state[app],
					showDocumentUpload: false,					
					showDemographicWarning: false,
					showInternationalWarning: false,
					documentUploaded: false,
					stagedDocuments: null,
					hideToast: false,					
				},
			};
		case DocumentUploadActionTypes.SET_TOAST_HIDE:
			return {
				...state,
				[app]: {
					...state[app],
					hideToast: action.payload,
				},
			};
		case DocumentUploadActionTypes.SET_UPLOAD_STATUS:
			return {
				...state,
				[app]: {
					...state[app],
					uploadStatus: action.payload,
				},
			};
		case DocumentUploadActionTypes.SET_RECEIVING_PENSION_PAYOUT:
			return {
				...state,
				[app]: {
					...state[app],
					isReceivingPensionOrPayout: action.payload,
				},
			};
		default: return state;
	}
};


export const toggleDocumentUpload = (show: boolean, app: DemographicAppKeys | GenericDocumentUpload, showInternationalWarning: boolean = false) => {
	return {
		type: DocumentUploadActionTypes.TOGGLE_DOCUMENT_UPLOAD,
		payload: {
			show : show || showInternationalWarning,
			showInternationalWarning,			
			showDemographicWarning: show,
		},
		app,
	};
};


export const setDocumentUploadStatus = (status: boolean, app: DemographicAppKeys | GenericDocumentUpload, documentCount: number = 0) => {
	return {
		type: DocumentUploadActionTypes.UPDATE_DOCUMENT_UPLOAD_STATUS,
		payload: {
			status,
			documentCount,
		},
		app,
	};
};

export const stageDocuments = (documents: File[], app: DemographicAppKeys | GenericDocumentUpload) => {
	return {
		type: DocumentUploadActionTypes.STAGE_DOCUMENTS,
		payload: documents,
		app,
	};
};


export const resetDocState = (app: DemographicAppKeys | GenericDocumentUpload) => {
	return {
		type: DocumentUploadActionTypes.RESET_DOC_STATE,
		app,
	};
};


export const setDocToastHide = (hide: boolean, app: DemographicAppKeys | GenericDocumentUpload) => {
	return {
		type: DocumentUploadActionTypes.SET_TOAST_HIDE,
		payload: hide,
		app,
	};
};


export const setDocUploadApiStatus = (status: ApiStatuses, app: DemographicAppKeys | GenericDocumentUpload) => {
	return {
		type: DocumentUploadActionTypes.SET_UPLOAD_STATUS,
		payload: status,
		app,
	};
};

export const setIsReceivingPensionOrPayout = (newValue: boolean, app: DemographicAppKeys | GenericDocumentUpload) => {
	return {
		type: DocumentUploadActionTypes.SET_RECEIVING_PENSION_PAYOUT,
		payload: newValue,
		app,
	};
};

